import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { refreshAccessToken } from './refreshAccessToken';

interface IAuthState {
    accessToken: string | null;
}

const initialState: IAuthState = {
    accessToken: null,
};

const authSlice = createSlice({
    name: 'auth',
    initialState,
    reducers: {
        setAccessToken: (state, action: PayloadAction<string | null>) => {
            state.accessToken = action.payload;
        },
        clearAccessToken: (state) => {
            state.accessToken = null;
        },
    },
    extraReducers: (builder) => {
        builder.addCase(refreshAccessToken.fulfilled, (state, action) => {
            state.accessToken = action.payload;
        });
        builder.addCase(refreshAccessToken.rejected, (state) => {
            state.accessToken = null;
        });
    },
});

export const { setAccessToken, clearAccessToken } = authSlice.actions;
export default authSlice;
